import React from 'react'

interface IDialogMessage {
  children: any;
}

export const DialogMessage = React.memo(({ children }: IDialogMessage) => (<div className="dialog-message text-center">{children}</div>))